import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type PriceRange } from '@/scripts/catalog/price-range'
type FilterDataElement = { html: string; url: string }
export class Filters {
	searchParamsInitial: string
	searchParamsPrev: string
	filterData: FilterDataElement[]

	constructor() {
		this.filterData = []
		this.searchParamsInitial = window.location.search.slice(1)
		this.searchParamsPrev = window.location.search.slice(1)
		const facetWrapper = q.os('#FacetsWrapperDesktop')
		if (facetWrapper)
			facetWrapper.addEventListener('keyup', q.onKeyUpEscape)
	}

	static setListeners() {
		const onHistoryChange = (event: PopStateEvent) => {
			const searchParams = event.state
				? event.state.searchParams
				: window.Filters.searchParamsInitial
			if (searchParams === window.Filters.searchParamsPrev) return
			Filters.renderPage(searchParams, null, false)
		}
		window.addEventListener('popstate', onHistoryChange)
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable)
		})
		if (window.innerWidth > 990) {
			q.ol('input[data-disable-breakpoint="desktop"]')?.forEach((element) => {
				element.setAttribute('disabled', '')
			})
		} else {
			q.ol('input[data-disable-breakpoint="mobile"]')?.forEach((element) => {
				element.setAttribute('disabled', '')
			})
		}
	}

	static renderPage(
		searchParams: string,
		event: InputEvent | null,
		updateURLHash = true
	) {
		window.Filters.searchParamsPrev = searchParams
		const sections = Filters.getSections()
		const countContainers = q.ol('[data-filter-product-count]')
		const loadingSpinners = document.querySelectorAll(
			'[data-filter-loading-spinner]'
		)
		loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'))
		q.rs('[data-product-grid]').classList.add('loading')
		countContainers?.forEach((container) => {
			container.classList.add('loading')
		})

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
			const filterDataUrl = (element: FilterDataElement) =>
				element.url === url

			window.Filters.filterData.some(filterDataUrl)
				? Filters.renderSectionFromCache(filterDataUrl, event)
				: Filters.renderSectionFromFetch(url, event)
		})

		if (updateURLHash) Filters.updateURLHash(searchParams)
	}

	static renderSectionFromFetch(
		url: string,
		event: PopStateEvent | InputEvent | null
	) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText
				window.Filters.filterData = [
					...window.Filters.filterData,
					{ html, url },
				]
				Filters.renderFilters(html, event)
				Filters.renderProductGridContainer(html)
				Filters.renderProductCount(html)
				/*if (typeof initializeScrollAnimationTrigger === 'function')
					initializeScrollAnimationTrigger(html.innerHTML)*/
			})
	}

	static renderSectionFromCache(
		filterDataUrl: (el: FilterDataElement) => boolean,
		event: PopStateEvent | InputEvent | null
	) {
		const html = window.Filters.filterData.find(filterDataUrl)?.html
		if (!html) {
			throw new Error('Trying to render from cache but cache not found')
		}
		Filters.renderFilters(html, event)
		Filters.renderProductGridContainer(html)
		Filters.renderProductCount(html)
		/*if (typeof initializeScrollAnimationTrigger === 'function')
			initializeScrollAnimationTrigger(html.innerHTML)*/
	}

	static renderProductGridContainer(html: string) {
		const selector = '[data-dynamic-collection-area]'
		const el = q.rs(selector)
		el.innerHTML = q.rs(
			selector,
			new DOMParser().parseFromString(html, 'text/html')
		).innerHTML

		q.ol('.scroll-trigger', el)?.forEach((element) => {
			element.classList.add('scroll-trigger--cancel')
		})

		// Dispatch event after grid is updated
		document.dispatchEvent(new CustomEvent('filter:updated'))
	}

	static renderProductCount(html: string) {
		const newDom = new DOMParser().parseFromString(html, 'text/html')
		q.rl(
			'[data-filter-product-count]'
		).forEach((el) => {
			const a = q.ra(el, 'data-filter-product-count')
			const newEl = q.os(`[data-filter-product-count="${a}"]`, newDom)
			if (!newEl) return
			el.innerHTML = newEl.innerHTML
			el.classList.remove('loading')

		})

		const loadingSpinners = document.querySelectorAll(
			'[data-filter-loading-spinner]'
		)
		loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'))
	}

	static renderFilters(html: string, event: Event | null) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
		const newEls = q.rl('[data-filter-el]', parsedHTML)
		const currentEls = q.rl('[data-filter-el]')

		// Remove facets that are no longer returned from the server
		currentEls.forEach((el) => {
			if (!Array.from(newEls).some(({ id }) => el.id === id)) {
				el.remove()
			}
		})

		const matchesId = (element: HTMLElement) => {
			const jsFilter = event
				? q.oClosestTarget(event, '[data-filter-el]')
				: undefined
			return jsFilter ? element.id === jsFilter.id : false
		}

		const facetsToRender = Array.from(newEls).filter(
			(element) => !matchesId(element)
		)
		console.log({facetsToRender})
		const countsToRender: HTMLElement | undefined =
			Array.from(newEls).find(matchesId)

		facetsToRender.forEach((elementToRender, _index) => {
			const newFilterContainer = q.rs(
				'[data-filter-container]',
				elementToRender as HTMLElement
			)
			const currentElement = document.getElementById(elementToRender.id)
			if (
				newFilterContainer.getAttribute('data-filter-container') ===
				'sort'
			)
				return

			if (currentElement) {
				q.rs('[data-filter-container]', currentElement).innerHTML =
					newFilterContainer.innerHTML

				const priceRange = q.os<PriceRange>('price-range', currentElement)
				if (priceRange) priceRange.reInitializeForSafari()
			} else {
				console.error('unexpected behavior - filter not present in DOM')
				console.log({ elementToRender, id: elementToRender.id })
				/*if (index > 0) {
					const {
						className: previousElementClassName,
						id: previousElementId,
					} = facetsToRender[index - 1]
					// Same facet type (eg horizontal/vertical or drawer/mobile)
					if (
						elementToRender.className === previousElementClassName
					) {
						q.rs(`#${previousElementId} [data-filter-container]`).after(elementToRender)
						return
					}
				}

				if (elementToRender.parentElement) {
					q.rs(
						`#${elementToRender.parentElement.id} [data-filter-el]`
					).before(elementToRender)
				}*/
			}
		})

		Filters.renderActiveFacets(parsedHTML)
		Filters.renderAdditionalElements(parsedHTML)
		if (!event) return
		const target = q.ot(event)
		if (!target) return
		const closestFilterEl = q.oc(target, '[data-filter-el]')
		if (!closestFilterEl) return // this is only the case for facet-remove
		if (countsToRender) {
			Filters.renderCounts(countsToRender, closestFilterEl)
		}

		const newFacetDetailsElement = q.os(`#${closestFilterEl.id}`)

		if (!newFacetDetailsElement) return

		const newElementToActivate = q.os(
			'[data-filter-container]',
			newFacetDetailsElement
		)

		const isTextInput = target.getAttribute('type') === 'text'

		if (newElementToActivate && !isTextInput) {
			console.log('newElementToActivate.focus()')
			newElementToActivate.focus()
		}
	}

	static renderActiveFacets(html: Document) {
		q.ol('[data-active-filters]', html)?.forEach((el) => {
			const handle = q.ra(el, 'data-active-filters')
			const oldEl = q.rs(`[data-active-filters="${handle}"]`)
			oldEl.innerHTML = el.innerHTML
		})

		Filters.toggleActiveFacets(false)
	}

	static renderAdditionalElements(_: Document) {
		// placeholder in case there are additional elements
	}

	static renderCounts(source: HTMLElement, target: HTMLElement) {
		const targetWrapElement = target.querySelector('.facets-wrap')
		const sourceWrapElement = source.querySelector('.facets-wrap')

		if (sourceWrapElement && targetWrapElement) {
			targetWrapElement.outerHTML = sourceWrapElement.outerHTML
		}
	}

	static updateURLHash(searchParams: string) {
		history.pushState(
			{ searchParams },
			'',
			`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
		)
	}

	static getSections() {
		return [
			{
				section: q.ra(q.rs('[data-product-grid]'), 'data-id'),
			},
		]
	}

	static onActiveFilterClick(event: Event, clear = false) {
		event.preventDefault()
		const t = q.rct<Event, HTMLAnchorElement>(event)
		if (clear) {
			const url = q.ra(t, 'href')
			Filters.renderPage(url, null, true)
			return
		}
		Filters.toggleActiveFacets()
		const url =
			t.href.indexOf('?') == -1
				? ''
				: t.href.slice(t.href.indexOf('?') + 1)
		Filters.renderPage(url, null, true)
	}
}
